import { render, staticRenderFns } from "./TransactionsPage.vue?vue&type=template&id=ed918490&scoped=true&"
import script from "./TransactionsPage.vue?vue&type=script&lang=js&"
export * from "./TransactionsPage.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsPage.vue?vue&type=style&index=0&id=ed918490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed918490",
  null
  
)

export default component.exports